// ============================================================================
// globals.js
// ============================================================================
//
// Imports all third-party libraries and exposes them as window globals.
// This file is automatically injected as the first import in every component
// file via the injectGlobals Vite plugin, ensuring that globals are always
// available before any component IIFE executes.
//
// This prevents ReferenceErrors in the IIFE bundle caused by Rollup's
// topological sort placing component files (with zero imports) before the
// code that sets window.Swiper, window.$, etc.
//
// ============================================================================

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Keyboard, A11y, Thumbs } from 'swiper/modules';
import 'fslightbox';
import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import Handlebars from 'handlebars/dist/handlebars.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Configure Swiper to use modules globally
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Keyboard, A11y, Thumbs]);

// Expose libraries as globals for component IIFEs
window.Swiper = Swiper;
window.$ = $;
window.jQuery = $;
window.Handlebars = Handlebars;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
